{
  "title": "Briefs",
  "table": {
    "name": "Name",
    "created": "Created",
    "actions": "Actions",
    "empty": "No briefs yet. Create one to give your assignments context."
  },
  "includeArchived": "Include archived",
  "new": "New brief",
  "archivedBadge": "Archived",
  "form": {
    "name": "Name",
    "description": "Description",
    "descriptionHelp": "Markdown is supported."
  },
  "createTitle": "New brief",
  "create": "Create brief",
  "created": "Brief created",
  "editTitle": "Edit brief",
  "edit": "Edit",
  "saved": "Brief saved",
  "archive": "Archive",
  "unarchive": "Restore",
  "archivedToast": "Brief archived",
  "unarchivedToast": "Brief restored",
  "noDescription": "No description yet.",
  "assignmentsTitle": "Assignments using this brief",
  "notFound": "Brief not found."
}
